/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsAdmin } from "../../entities/models/Admin";
import { z } from "zod/v4";

export const modelsAdminSchema = z.object({
    "branch_id": z.optional(z.int()),
"company_id": z.optional(z.int()),
"created_at": z.optional(z.string()),
"email": z.optional(z.string()),
"id": z.optional(z.int()),
"is_active": z.optional(z.boolean()),
"name": z.optional(z.string()),
"role": z.optional(z.string()),
"updated_at": z.optional(z.string())
    }) as unknown as z.ZodType<ModelsAdmin>